import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import getConfig from '../config';

const { version } = getConfig();

const loadTranslations = (lang: string): Promise<{}> =>
  fetch(`/translations/${lang}/translation.json?${version}`)
    .then((resp: Response) => resp.json())
    .then((translation: {}) => ({ [lang]: { translation } }));

const getI18n = (lng: string): Promise<any> => {
  return loadTranslations(lng).then((resources: {}) =>
    i18n.use(initReactI18next).init({
      lng,
      resources,
      interpolation: { escapeValue: false },
    })
  );
};

export default getI18n;
